const projects = [
  {
    tag: "systems",
    src: ["assets/mockups/bugWatch.svg"],
    title: "Bug Watch: Bug Tracker",
    mini_body:
      "Bug Watch is a Bug Tracker for your Github Repositories. Track your Bugs and Features using GitHub API.",
    body: "Bug Watch is a Bug Tracker for your Github Repositories. Track your Bugs and Features in a single place using GitHub API. Bug watch is full stack project powered by Github API and is built using React, Express, NodeJS, MongoDB, and Tailwind CSS.",
    link: "https://bugwatch.netlify.app",
    skills: [
      "assets/icons/nodejs.svg",
      "assets/icons/express.svg",
      "assets/icons/react.svg",
      "assets/icons/tailwind.svg",
      "assets/icons/mongodb.svg",
    ],
    span: "",
    // date: "Mar 2023",
  },
  {
    src: ["assets/mockups/statify-v2.svg"],
    title: "Statify: Spotify Tracker",
    mini_body:
      "Track your Spotify activity, stats, and dive deep into your music journey",
    body: "Spotify Stats Dashboard where you can dive deep into your music journey. This user-friendly platform, built with React and Tailwind CSS, employs a graphing library to visually represent Spotify data, showcasing my understanding of OAuth 2.0 authentication mechanism and consuming external APIs securely.",
    link: "https://statify-dev.netlify.app",
    skills: [
      "assets/icons/react.svg",
      "assets/icons/tailwind.svg",
      "assets/icons/recharts.svg",
      "assets/icons/spotify-devs.svg",
    ],
    span: "",
    // date: "Oct 2023",
  },
  {
    tag: "BI",
    src: ["assets/mockups/mobile_proj-v2.svg"],
    title: "Inventory Management",
    span: "",
    mockup: "iphone",
    width: "600px",
    height: "400px",
    mini_body:
      "A freelance mobile app, I converted the customer requirements and ideas into a fully functional application.",
    body: "As the developer of this freelance mobile app, I converted the customer requirements and ideas into a fully functional application. Built on NodeJS/ExpressJS with MongoDB in the backend. And React Native, with Native-Base and React-Navigation, for the frontend. The app offers seamless inventory management, real-time stats, and secure login capabilities.",
    link: "https://github.com/bilal-auz/Inventory_Management_Mobile-App",
    skills: [
      "assets/icons/ReactN.svg",
      "assets/icons/nativeBase.svg",
      "assets/icons/Nodejs.svg",
      "assets/icons/mongodb.svg",
    ],
    // date: "Mar 2022",
  },
  {
    tag: "webapp",
    src: ["assets/mockups/MacBook.svg"],
    mockup: "laptop",
    title: "Travel Guide Provider",
    mini_body: "Help people know more about their next traveling destination.",
    body: "As the developer of this portfolio project, my focus was on developing a robust backend system that efficiently utilizes external APIs to provide real-time travel data. The website empowers users to access comprehensive information on hotels, flight ticket prices, restaurants, and captivating visuals through a seamless search functionality, highlighting my technical skills in backend development and data integration.",
    link: "https://github.com/bilal-auz/Travel_Guider",
    skills: [
      "assets/icons/laravel.svg",
      "assets/icons/mysql.svg",
      "assets/icons/mongodb.svg",
      "assets/icons/bootstrap.svg",
    ],
    // date: "Aug 2021",
  },
  {
    tag: "webapp",
    src: ["assets/mockups/blog_ipad.svg"],
    mockup: "ipad",
    title: "NodeJS CRUD BLOG",
    mini_body:
      "Blog where you can login to your account and write blogs and comment others people blogs.",
    body: "This project showcases my skills in building core backend functionalities. The Key features include user authentication with login and register functionality, enabling users to add, edit, and delete blogs effortlessly. Additionally, users can interact and engage with the content by adding, editing, and deleting comments on each blog post.",
    link: "https://github.com/bilal-auz/Blog-Backend-Personal-Project",
    skills: [
      "assets/icons/Nodejs.svg",
      "assets/icons/express.svg",
      "assets/icons/mongodb.svg",
      "assets/icons/bootstrap.svg",
    ],
    // date: "Jan 2021",
  },
];

export default projects;
